import React, { useState } from 'react';
import { Button, Grid, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import Modal from '../common/Modal';
import Steps from '../common/Steps';
import JourneyList from './JourneyList';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import RecipientList from './RecipientList';
import AssignDueDate from './AssignDueDate';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyle = makeStyles({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  contentBox: {
    height: '60vh',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    padding: '15px 10px',
  },
});

export default function AssignJourneyPopup({ isOpen, setIsOpen, callFrom, dealershipId }) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const delaershipHeader = useSelector((state) => state.DealershipDetails.dealershipdetails);

  const [step, setStep] = useState(1);
  const [selectedJ, setSelectedJ] = useState({});
  const [recipients, setRecipients] = useState([]);
  const [roles, setRoles] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const [selectedEmpUnderRole, setSelectedEmpUnderRole] = useState({});
  const [dealerId, setDealerId] = useState(null);

  useState(() => {
    if (callFrom === 'px') {
      setDealerId(dealershipId);
    } else {
      setDealerId(delaershipHeader.id);
    }
  }, [delaershipHeader]);

  const validation = () => {
    if (step === 1 && _isEmpty(selectedJ)) {
      ErrorToast('Please select a journey');
      return false;
    }
    if (step === 2) {
      let empHashList = [];
      Object.keys(selectedEmpUnderRole).forEach((key) => {
        if (!roles.includes(Number(key))) {
          empHashList = empHashList.concat(selectedEmpUnderRole[key]);
        }
      });
      setRecipients(empHashList);
      if (empHashList.length === 0 && roles.length === 0) {
        ErrorToast('Please select a recipient');
        return false;
      }
    }
    if (step === 3 && !dueDate) {
      ErrorToast('Please select due date');
      return false;
    }
    if (dueDate && moment(dueDate).isSameOrBefore(moment(), 'day')) {
      ErrorToast('Due date must be in future');
      return false;
    }
    return true;
  };

  const onNext = async () => {
    if (validation()) {
      if (step < 3) {
        setStep((pre) => pre + 1);
      }

      if (step === 3) {
        dispatch(showProgress(true));
        const payload = {
          dealershipIds: [{ id: dealerId, departmentRoleIds: roles?.length > 0 ? roles : undefined }],
          journeyIds: [selectedJ.id],
          type: 3,
          dueDate: moment(dueDate).format('YYYY-MM-DD'),
        };
        if (recipients.length > 0) {
          payload.receiversHash = recipients;
        }
        try {
          await service.post(apiEndpoints.DEALER_JOURNEY_ASSIGN, payload);
          notifySuccess('Journey assigned successfully!');
          setIsOpen(false);
        } catch (error) {
          ErrorToast(error);
        }
        dispatch(showProgress(false));
      }
    }
  };

  return (
    <Modal isOpen={isOpen} height="85vh" width="55vw">
      <Grid className={classes.container}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Grid item style={{ fontWeight: '600', fontSize: '18px' }}>
              Assign Journey
            </Grid>
          </Grid>
          <Grid item>
            <CloseIcon onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        <Steps step={step} stepInfo={['Select a Journey', 'Select Recipients', 'Due Date']} />
        <Grid className={classes.contentBox}>
          {step === 1 && (
            <JourneyList
              selectedJ={selectedJ}
              setSelectedJ={setSelectedJ}
              callFrom={callFrom}
              dealershipId={dealershipId}
            />
          )}
          {step === 2 && (
            <RecipientList
              slectedJId={selectedJ.id}
              roles={roles}
              setRoles={setRoles}
              selectedEmpUnderRole={selectedEmpUnderRole}
              setSelectedEmpUnderRole={setSelectedEmpUnderRole}
              type="assign"
              callFrom={callFrom}
              dealershipId={dealershipId}
            />
          )}
          {step === 3 && <AssignDueDate dueDate={dueDate} setDueDate={setDueDate} selectedJ={selectedJ} />}
        </Grid>
        <Grid style={{ display: 'flex' }}>
          {step > 1 && (
            <Button
              onClick={() => {
                if (step === 2) {
                  setRecipients([]);
                  setRoles([]);
                  setSelectedEmpUnderRole({});
                }
                if (step === 3) {
                  setDueDate(null);
                }
                setStep((pre) => pre - 1);
              }}
              variant="outlined"
            >
              Back
            </Button>
          )}
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <>
              <Button onClick={() => setIsOpen(false)} variant="outlined">
                Cancel
              </Button>
              <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onNext}>
                {step !== 3 ? 'Next' : 'Assign'}
              </Button>
            </>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
